import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(p => {
        if (p >= 100) { clearInterval(interval); return 100; }
        return p + Math.random() * 18;
      });
    }, 120);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-bg" />
      <div className="loading-content">
        {/* Sri Yantra-inspired logo mark */}
            <img src='/assets/logo/logo-removebg-preview.png' style={{height:"8vh"}} />

        {/* <div className="loading-logo">

          <div className="logo-ring ring-1" />
          <div className="logo-ring ring-2" />
          <div className="logo-ring ring-3" />

          <div className="logo-center">
            <span className="logo-s">S</span>
          </div>
        </div> */}
        <div className="loading-brand">
          {/* <span className="loading-name">SHIVKMS</span> */}
          <span className="loading-tagline">Shiv Kirpa Multi Solution</span>
        </div>
        <div className="loading-bar-wrap">
          <div className="loading-bar" style={{ width: `${Math.min(progress, 100)}%` }} />
        </div>
        <p className="loading-status">Initializing Platform…</p>
      </div>
    </div>
  );
}
